import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import API from "../api";
import logo from "../assets/Logo.png";
import "../Style/UnlockPage.css";

export default function UnlockPage() {
    const [code, setCode]     = useState("");
    const [err, setErr]       = useState("");
    const [loading, setLoading] = useState(false);
    const navigate  = useNavigate();
    const location  = useLocation();

    const handleUnlock = async () => {
        if (!code.trim()) return;
        setErr("");
        setLoading(true);
        try {
            await API.post("/api/unlock", { code });
            localStorage.setItem("site_unlocked", "true");
            localStorage.setItem("site_unlocked_time", Date.now().toString());
            const backTo = location.state?.from || "/";
            navigate(backTo, { replace: true });
        } catch {
            setErr("Սխալ կոդ։ Կրկին փորձեք։");
        } finally {
            setLoading(false);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") handleUnlock();
    };

    return (
        <div className="unlock-page">
            <div className="unlock-card">
                <div className="unlock-logo">
                    <img src={logo} alt="Sovorir IT" />
                </div>

                <div className="unlock-icon">🔒</div>
                <h2 className="unlock-title">Կայքը դեռ բաց չէ</h2>
                <p className="unlock-subtitle">Մուտք գործելու համար մուտքագրեք հատուկ կոդը</p>

                <input
                    className="unlock-input"
                    type="password"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    onKeyDown={handleKeyDown}
                    placeholder="Մուտքագրեք կոդը"
                    autoComplete="off"
                />

                {err && <p className="unlock-error">{err}</p>}

                <button
                    className="unlock-btn"
                    onClick={handleUnlock}
                    disabled={loading || !code.trim()}
                >
                    {loading ? "Ստուգվում է..." : "Բացել կայքը"}
                </button>
            </div>
        </div>
    );
}
